import React from 'react'
import { navigate } from 'gatsby'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import { TabBar, TabItem } from '@storaensods/seeds-react'
import { renderRichText } from '../utils'


class PageTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: this.props.activeTab }
  }
  
  render() {
    if(this.props.tab.node.items === null || this.props.tab.node.items === undefined) {
      return null;
    }
    return (
      <React.Fragment>
        <TabBar>
          {this.props.tab &&
            this.props.tab.node.items.map(item => (
              <TabItem 
               isActive={this.state.activeTab === item.id}
               onClick={()=> this.setState({activeTab: item.id})}
               key={item.label}>{item.label}</TabItem>
            ))}
        </TabBar>
        <div>
          {this.props.tab &&
            this.props.tab.node.items.map(itemTab => (
              <div style={{display: this.state.activeTab === itemTab.id ? "block" : "none"}} key={itemTab.label}>
                {itemTab && renderRichText(itemTab.content.json)}
              </div>
            ))}
        </div>
      </React.Fragment>
    )
  }
}
export default PageTabs
